import { styled } from "@mui/material";
import { Image } from "components/img/Image";
import { MeasureImpact } from "types/types";

interface Props {
  measure: MeasureImpact;
}

export function MeasureItem(props: Props) {
  const { measure } = props;
  return (
    <StyledDiv>
      <Image defaultIcon={<></>} src={`${measure.measure.imageUrl}`} />
      <div className="image-overlay"></div>
      <div className="measure-label-div">{measure.measure.name}</div>
    </StyledDiv>
  );
}

const StyledDiv = styled("div")`
  position: relative;
  height: fit-content;
  min-height: 100px;
  width: 100%;
  min-width: 160px;
  max-width: 200px;

  .image-overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.6) 70%
    );
  }
  .measure-label-div {
    position: absolute;
    bottom: ${({ theme }) => theme.spacing(1)};
    left: ${({ theme }) => theme.spacing(1)};
    color: white;
    font-weight: bold;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
